import PropTypes from 'prop-types';
import { Row } from 'antd';

import TitleDivider from '../../TitleDivider/TitleDivider';
import ElementMenuItem from './ElementMenuItem';

function ElementMenuGroup({ title, elements, ...rest }) {
  return (
    <div className="elements-menu-group">
      <TitleDivider className="divider" content={title} />

      <Row gutter={[24, 24]} className="items">
        {elements.map((element) => (
          <ElementMenuItem key={element.type} {...element} {...rest} />
        ))}
      </Row>
    </div>
  );
}

ElementMenuGroup.propTypes = {
  title: PropTypes.string,
  elements: PropTypes.array,
};

export default ElementMenuGroup;
